import { cn } from '../lib/cn';

export const navItemStyles = cn(
  'flex h-7 w-full items-center gap-2 rounded-md px-2 text-left text-sm text-text-2 outline-none',
  'hover:bg-bg-3 hover:text-text-1 focus-visible:ring-2 focus-visible:ring-focus [&_svg]:size-4 [&_svg]:text-text-3',
  'aria-[current=page]:bg-bg-4 aria-[current=page]:text-text-1',
);
